/**
 * This code was AUTOGENERATED using the Codama library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun Codama to update it.
 *
 * @see https://github.com/codama-idl/codama
 */

import {
  addDecoderSizePrefix,
  addEncoderSizePrefix,
  combineCodec,
  getAddressDecoder,
  getAddressEncoder,
  getStructDecoder,
  getStructEncoder,
  getU32Decoder,
  getU32Encoder,
  getU64Decoder,
  getU64Encoder,
  getUtf8Decoder,
  getUtf8Encoder,
  type Address,
  type Codec,
  type Decoder,
  type Encoder,
} from "@solana/kit";

export type DeliverySubmittedEvent = {
  escrowId: bigint;
  agent: Address;
  deliveryProof: string;
};

export type DeliverySubmittedEventArgs = {
  escrowId: number | bigint;
  agent: Address;
  deliveryProof: string;
};

export function getDeliverySubmittedEventEncoder(): Encoder<DeliverySubmittedEventArgs> {
  return getStructEncoder([
    ["escrowId", getU64Encoder()],
    ["agent", getAddressEncoder()],
    ["deliveryProof", addEncoderSizePrefix(getUtf8Encoder(), getU32Encoder())],
  ]);
}

export function getDeliverySubmittedEventDecoder(): Decoder<DeliverySubmittedEvent> {
  return getStructDecoder([
    ["escrowId", getU64Decoder()],
    ["agent", getAddressDecoder()],
    ["deliveryProof", addDecoderSizePrefix(getUtf8Decoder(), getU32Decoder())],
  ]);
}

export function getDeliverySubmittedEventCodec(): Codec<
  DeliverySubmittedEventArgs,
  DeliverySubmittedEvent
> {
  return combineCodec(
    getDeliverySubmittedEventEncoder(),
    getDeliverySubmittedEventDecoder(),
  );
}
